import { render, staticRenderFns } from "./ProfileFollowersPage.vue?vue&type=template&id=05ac53ae&scoped=true&"
import script from "./ProfileFollowersPage.vue?vue&type=script&lang=js&"
export * from "./ProfileFollowersPage.vue?vue&type=script&lang=js&"
import style0 from "./ProfileFollowersPage.vue?vue&type=style&index=0&id=05ac53ae&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ac53ae",
  null
  
)

export default component.exports